export default __webpack_public_path__ + "assets/svg/Cable.da55785063bbaf2ebde0a9952f554223.svg";